/**
 * Özet rapor oluşturur.
 * @param {Array} bilancoVerileri - Bilanço verileri
 * @param {Array} gelirTablosuVerileri - Gelir tablosu verileri
 * @param {Object} sermayeArtirimlariTemettuler - Sermaye artırımları ve temettüler verileri
 * @param {Array} tarihselFiyatBilgileri - Tarihsel fiyat bilgileri
 * @param {Object} sirketBilgileri - Şirket bilgileri
 * @returns {Object|null} Özet rapor veya null (eğer veri eksikse)
 */

export const generateOzetRapor = (
  bilancoVerileri,
  gelirTablosuVerileri,
  sermayeArtirimlariTemettuler,
  tarihselFiyatBilgileri,
  sirketBilgileri
) => {
  // Verilerin var olup olmadığını kontrol et
  if (
    !bilancoVerileri ||
    !gelirTablosuVerileri ||
    // !sermayeArtirimlariTemettuler ||
    !tarihselFiyatBilgileri ||
    !sirketBilgileri
  ) {
    console.error("Özet rapor oluşturulamadı: Eksik veri");
    return null;
  }

  // Bilanço verilerini filtrele
  const anaOrtaklikOzKaynaklar = bilancoVerileri.filter(
    (item) => item.metric === "Ana Ortaklığa Ait Özkaynaklar"
  );
  const odenmisSermaye = bilancoVerileri.filter(
    (item) => item.metric === "Ödenmiş Sermaye"
  );

  // Gelir tablosu verilerini filtrele
  const faaliyetKari = gelirTablosuVerileri.filter(
    (item) => item.metric === "Faaliyet Karı (Zararı)"
  );
  const satisGelirleri = gelirTablosuVerileri.filter(
    (item) => item.metric === "Satış Gelirleri"
  );
  const brutKar = gelirTablosuVerileri.filter(
    (item) => item.metric === "Brüt Kar (Zarar)"
  );
  const anaOrtaklikPaylari = gelirTablosuVerileri.filter(
    (item) => item.metric === "Ana Ortaklık Payları"
  );
  const donemKari = gelirTablosuVerileri.filter(
    (item) => item.metric === "Dönem Karı (Zararı)"
  );

  // Sermaye artırımları ve temettüler verilerini kontrol et
  let sermayeArtirimlari = null;
  let temettuler = null;

  try {
    if (
      sermayeArtirimlariTemettuler &&
      sermayeArtirimlariTemettuler.sermaye_artirimlari &&
      Array.isArray(sermayeArtirimlariTemettuler.sermaye_artirimlari) &&
      sermayeArtirimlariTemettuler.sermaye_artirimlari.length > 0
    ) {
      sermayeArtirimlari = sermayeArtirimlariTemettuler.sermaye_artirimlari[0];
    }

    if (
      sermayeArtirimlariTemettuler &&
      sermayeArtirimlariTemettuler.temettuler &&
      Array.isArray(sermayeArtirimlariTemettuler.temettuler) &&
      sermayeArtirimlariTemettuler.temettuler.length > 0
    ) {
      temettuler = sermayeArtirimlariTemettuler.temettuler[0];
    }
  } catch (error) {
    console.error(
      "Sermaye artırımları veya temettüler verileri okunurken hata oluştu:",
      error
    );
    sermayeArtirimlari = null;
    temettuler = null;
  }

  // Tarihsel fiyat verilerini kontrol et
  const tarihselFiyat =
    tarihselFiyatBilgileri && tarihselFiyatBilgileri.length > 0
      ? tarihselFiyatBilgileri[tarihselFiyatBilgileri.length - 1]
      : null;

  // Özet raporu döndür
  return {
    bilanco: {
      anaOrtaklikOzKaynaklar,
      odenmisSermaye,
    },
    gelirTablosu: {
      faaliyetKari,
      satisGelirleri,
      anaOrtaklikPaylari,
      donemKari,
      brutKar,
    },
    sermayeArtirimlari,
    temettuler,
    tarihselFiyat,
    sirketBilgileri,
  };
};
